<template>
  <section class="signin">
    <form class="form">
      <section
        class="form-errors"
        v-if="formErrorMessage"
      >
        {{ formErrorMessage }}
      </section>

      <v-text-field
        type="email"
        label="Email"
        v-model="email"
        :error-messages="emailError"
      />

      <v-text-field
        type="password"
        label="Password"
        v-model="password"
      />

      <v-btn
        depressed
        color="grey"
        @click="submit"
      >
        Sign in
      </v-btn>
    </form>
  </section>
</template>
<script>
import simpleVueValidation from 'simple-vue-validator';
import { envConfig } from '@/appConfig.js';

const { Validator } = simpleVueValidation;
const { urlBase } = envConfig;

export default {
  data() {
    return {
      inputs: ['email', 'password'],
      email: '',
      password: '',
      formErrorMessage: '',
    };
  },
  validators: {
    email(value) {
      return Validator.value(value).required().email();
    },
  },
  methods: {
    getFormData() {
      return this.inputs.reduce((data, input) => {
      // eslint-disable-next-line no-param-reassign
        data[input] = this[input];
        return data;
      }, {});
    },
    clearFormData() {
      this.inputs.forEach((input) => {
        this[input] = '';
      });
    },
    submit() {
      this.$validate().then(async (success) => {
        if (success) {
          const formData = this.getFormData();

          const response = await this.$store.dispatch('signin', { urlBase, formData }).catch((error) => {
            if (
              (error.response.data.type && error.response.data.type === 'passwordHash')
              || (error.response.data.type && error.response.data.type === 'username')
            ) {
              this.formErrorMessage = 'Invalid username or password.';
            } else {
              this.formErrorMessage = 'Sorry we are having trouble processing your request. Please Try again later.';
            }
          });

          if (response) {
            this.$router.push('/dashboard');
          }
        }
      });
    },
  },
  computed: {
    emailError() {
      return this.validation.firstError('email');
    },
  },
};

</script>
<style lang=scss>
  .signin {
    .form {
      margin: 5em auto;
      width: 18em;
    }
    .form-errors {
      background-color: red;
      border-radius: 5px;
      color: white;
      font-weight: bold;
      margin-bottom: 2.5em;
      padding: 1em;
      text-align: center;
    }
  }
</style>
